import { useCallback } from 'react';

import { Accordion, Button, Pill } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { Consent } from '../types';
import { ConsentDetails } from './ConsentDetails';

type ConsentAccordionProps = {
    handleDisconnectClick: (consentId: string) => void;
    consent: Consent;
};

export const ConsentAccordion = ({
    handleDisconnectClick: handleDisconnectClick,
    consent
}: ConsentAccordionProps) => {
    const titleText =
        consent.tpp_name === consent.app_name
            ? consent.tpp_name
            : `${consent.tpp_name} (${consent.app_name})`;

    const title = (
        <span className="flex w-full items-center gap-m">
            {titleText}
            {consent.active ? <ConnectedPill /> : <DisconnectedPill />}
        </span>
    );

    const onDisconnectClick = useCallback(
        () => handleDisconnectClick(consent.consent_id),
        [handleDisconnectClick, consent.consent_id]
    );

    return (
        <Accordion title={title}>
            {/* Add in logo */}
            <ConsentDetails consent={consent} />
            <>
                {consent.active && (
                    <Button
                        variant="action"
                        size="small"
                        className="mt-m"
                        onClick={onDisconnectClick}
                    >
                        <FormattedMessage
                            id="_.credit_card.preferences.consent_accordion.disconnect_app"
                            defaultMessage="Disconnect app"
                        />
                    </Button>
                )}
            </>
        </Accordion>
    );
};

const ConnectedPill = () => {
    return (
        <Pill variant="green" className="ml-auto">
            <FormattedMessage
                id="_.credit_card.preferences.consent_accordion.connected"
                defaultMessage="Connected"
            />
        </Pill>
    );
};

const DisconnectedPill = () => {
    return (
        <Pill variant="london" className="ml-auto">
            <FormattedMessage
                id="_.credit_card.preferences.consent_accordion.disconnected"
                defaultMessage="Disconnected"
            />
        </Pill>
    );
};
